module.exports = __webpack_public_path__ + "static/media/error1.26fb2114.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/error1.svg
// module id = 49
// module chunks = 0